import React from 'react'
const BlockContent = require('@sanity/block-content-to-react')
import serializer from '../../serializers/post'

const Body = ({ _rawBody, addClass }) => {
  return (
    <section className={`blog-body ${addClass == undefined ? '' : addClass}`}>
      <BlockContent
        blocks={_rawBody}
        serializers={serializer}
        className="body-block"
      />
    </section>
  )
}

export default Body
